import { Ng2StateDeclaration, Transition } from '@uirouter/angular';
import { LoggingService } from '../shared/services/logging/logging.service';
import { CategoriesService } from '../shared/category/categories.service';
import { Process } from '../shared';
import * as fromHelpDesk from './feature';

const log = new LoggingService();

export const HelpDeskRoute: Ng2StateDeclaration = {
    // name: 'HelpDesk.**'
    name: 'helpdesk',
    url: '/helpdesk',
    // , loadChildren: () => import('./leave-request.module').then(r => r.HelpDeskModule)
    data: { requiresAuth: true },
    params: { process: {} },
    component: fromHelpDesk.HelpDeskFeatureComponent
};
